export default "__VITE_ASSET__CJPRSYNY__"